export default __webpack_public_path__ + "static/media/user-icon.074e325c.svg";